define('taoQtiItem/qtiXmlRenderer/renderers/interactions/GraphicOrderInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'graphicOrderInteraction',
        template : tpl
    };
});
